import { ISelectOption } from "components/common/CustomSelect";

export const layer: ISelectOption[] = [
    { value: '1', label: '화주 (수출자 또는 수입자)', labelEn: 'Shipper (Exporter or Importer)' },
    { value: '2', label: '포워더', labelEn: 'Freight Forwarder' },
    { value: '3', label: '선사', labelEn: 'Shipping Line' },
    { value: '4', label: '관세사', labelEn: 'Customs Broker' },
    { value: '5', label: '운송사', labelEn: 'Trucking Company' },
    { value: '6', label: '특송', labelEn: 'Courier Service' },
    { value: '7', label: '하역사 (터미널)', labelEn: 'Stevedore (Terminal)' },
    { value: '8', label: '창고 (CFS)', labelEn: 'Warehouse (CFS)' },
    { value: '9', label: '물류 IT', labelEn: 'Logistics IT' },
    { value: '10', label: '기관 협회', labelEn: 'Organization / Association' },
    { value: '11', label: '항공사', labelEn: 'Airline' },
    { value: '12', label: '포장', labelEn: 'Packaging' },
    { value: '13', label: '장비', labelEn: 'Equipment Provider' },
    { value: '14', label: '무역컨설팅', labelEn: 'Trade Consulting' },
];